export const baseHeaderLabel = {
  props: {
    centered: {
      type: Boolean,
      required: false
    },
    currentBid: {
      type: Number,
      required: true
    },
    hasProcessingBid: {
      type: Boolean,
      required: false,
    },
    hiddenWhenEmpty: {
      type: Boolean,
      required: false,
      default: false
    },
    isHighBidder: {
      type: Boolean,
      required: true
    },
    isItemClosed: {
      type: Boolean,
      required: false
    },
    isOutbid: {
      type: Boolean,
      required: false,
      default: false
    },
    isVerifying: {
      type: Boolean,
      required: false,
      default: false
    },
    maxBid: {
      type: Number,
      required: false
    },
    showMaxBidLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      headerStatuses: {
        HIGH_BIDDER: 'high-bidder',
        OUTBID: 'outbid',
        WON: 'won',
        LOST: 'lost',
        SOLD: 'sold',
        UNSOLD: 'unsold',
        IS_BIDDING: 'is-bidding',
        VERIFYING: 'verifying',
      }
    }
  },
  computed: {
    hideHeaderLabel() {
      return !this.headerStatus && this.hiddenWhenEmpty;
    },
    headerStatus() {
      if (this.isVerifying) {
        return this.headerStatuses.VERIFYING;
      } else if (this.hasProcessingBid) {
        return this.headerStatuses.IS_BIDDING;
      } else if (this.isHighBidder) {
        if (this.isItemClosed) {
          return this.headerStatuses.WON;
        }
        return this.headerStatuses.HIGH_BIDDER;
      } else if (this.isOutbid) {
        if (this.isItemClosed) {
          return this.headerStatuses.LOST;
        }
        return this.headerStatuses.OUTBID;
      } else if (this.isItemClosed) {
        return this.currentBid ? this.headerStatuses.SOLD : this.headerStatuses.UNSOLD;
      }

      return null;
    },
  },
  methods: {
    headingHelper(getText = false) {
      const status = this.headerStatus;

      switch (status) {
        case this.headerStatuses.VERIFYING:
          if (getText) {
            return 'UPDATING';
          } else {
            return 'bg-info text-white';
          }
        case this.headerStatuses.IS_BIDDING:
          if (getText) {
            return 'Placing Bid...';
          } else {
            return 'bg-silver text-white';
          }
        case this.headerStatuses.WON:
          if (getText) {
            return 'Won';
          } else {
            return 'bg-success text-dark';
          }
        case this.headerStatuses.HIGH_BIDDER:
          if (getText) {
            return 'Winning';
          } else {
            return 'bg-success text-dark';
          }
        case this.headerStatuses.LOST:
          if (getText) {
            return 'Lost';
          } else {
            return 'bg-tomato text-dark';
          }
        case this.headerStatuses.OUTBID:
          if (getText) {
            return 'Outbid';
          } else {
            return 'bg-tomato text-dark';
          }
        case null:
        default:
          return '';
      }
    }
  },
}
